const validPnr = (input?: string): boolean => {
  if (!input || !/^\d{12}$/.test(input)) {
    return false
  }
  return true
}

export const formatPnr = (input: string | undefined): string => {
  if (!validPnr(input)) {
    return "Unknown"
  }

  const datePart = input!.slice(0, 8)
  const serialPart = input!.slice(8)

  return `${datePart}-${serialPart}`
}

export const getAgeFromPnr = (pnr?: string): number | undefined => {
  if (!validPnr(pnr)) {
    return
  }

  const year = parseInt(pnr!.slice(0, 4), 10)
  const month = parseInt(pnr!.slice(4, 6), 10) - 1
  const day = parseInt(pnr!.slice(6, 8), 10)

  const birthDate = new Date(year, month, day)
  const today = new Date()

  let age = today.getFullYear() - birthDate.getFullYear()

  // Adjust age if the birthday hasn't occurred yet this year
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate())

  if (!hasHadBirthdayThisYear) {
    age--
  }

  return age
}

export const getGenderFromPnr = (pnr?: string): "male" | "female" | "unknown" => {
  if (!validPnr(pnr)) {
    return "unknown"
  }

  return parseInt(pnr!.slice(10, 11)) % 2 === 0 ? "female" : "male"
}
